import { render, staticRenderFns } from "./ReservationBlock.vue?vue&type=template&id=f090ce52&scoped=true&"
import script from "./ReservationBlock.vue?vue&type=script&lang=js&"
export * from "./ReservationBlock.vue?vue&type=script&lang=js&"
import style0 from "./ReservationBlock.vue?vue&type=style&index=0&id=f090ce52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f090ce52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VIcon,VSelect,VTextField})
